<!DOCTYPE html>
<html>
<head>
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
</head>
<body>
   <div class="unauthorised d-flex flex-column justify-content-center align-items-center">
     <div class="circle d-flex justify-content-center align-items-center">
       <!-- <span class="icon-x-circle"></span> -->
       <i class="fa fa-times" aria-hidden="true"></i>
       <!-- <i class="fa fa-times-circle-o" aria-hidden="true"></i> -->
     </div>
     <span class="access-denied" >Access Denied</span>
     <span class="message" >You are not authorized to access the page, please contact the system administrator.</span>
     <!-- <span class="re-direct">Redirect to Login screen</span> -->
   </div>
</body>
</html>

